import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Lock, ArrowRight } from 'lucide-react';

export default function ClientPortal() {
  return (
    <div className="min-h-screen grid-bg flex items-center justify-center pt-16 pb-16">
      <div className="max-w-md w-full mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10"
          data-testid="portal-header"
        >
          <div className="logo-text text-[#1A2234] text-2xl tracking-wider mb-0.5">BOSFED®</div>
          <div className="text-[9px] text-[#475569] tracking-[0.2em] uppercase font-semibold mb-8">
            Boston Federal
          </div>
          <div className="w-14 h-14 rounded-2xl bg-[#0ABFBC]/10 flex items-center justify-center mx-auto mb-6">
            <Lock size={24} strokeWidth={1.5} className="text-[#0ABFBC]" />
          </div>
          <h1 className="text-3xl font-bold text-[#1A2234] mb-3">Client Portal</h1>
          <div
            className="inline-flex items-center gap-2 rounded-full bg-amber-50 border border-amber-200 text-amber-700 px-4 py-1.5 text-xs font-bold tracking-wider mb-4"
            data-testid="portal-coming-soon-badge"
          >
            COMING SOON
          </div>
          <p className="text-[#475569] text-sm leading-relaxed max-w-sm mx-auto">
            The BOSFED® Client Portal is currently under development. Secure client access,
            financial dashboards, and document sharing will be available soon.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="space-y-4 bg-white rounded-2xl border border-slate-100 p-8 shadow-[0_8px_30px_-4px_rgba(26,34,52,0.06)]"
          data-testid="portal-login-form"
        >
          <div>
            <label className="block text-[10px] font-bold uppercase tracking-[0.18em] text-[#1A2234] mb-2">
              Email Address
            </label>
            <input
              type="email"
              disabled
              placeholder="your@email.com"
              data-testid="portal-email"
              className="w-full border border-slate-200 rounded-md px-4 py-3 text-sm text-slate-400 placeholder-slate-300 bg-slate-50 cursor-not-allowed"
            />
          </div>
          <div>
            <label className="block text-[10px] font-bold uppercase tracking-[0.18em] text-[#1A2234] mb-2">
              Password
            </label>
            <input
              type="password"
              disabled
              placeholder="••••••••"
              data-testid="portal-password"
              className="w-full border border-slate-200 rounded-md px-4 py-3 text-sm text-slate-400 placeholder-slate-300 bg-slate-50 cursor-not-allowed"
            />
          </div>
          <button
            disabled
            data-testid="portal-login-btn"
            className="w-full bg-slate-100 text-slate-400 py-3.5 rounded-md font-semibold cursor-not-allowed flex items-center justify-center gap-2 mt-2"
          >
            <Lock size={15} /> Sign In — Portal Coming Soon
          </button>
          <p className="text-center text-xs text-[#475569] pt-1">
            Questions?{' '}
            <Link
              to="/contact"
              data-testid="portal-contact-link"
              className="text-[#0ABFBC] font-bold hover:underline"
            >
              Contact Us
            </Link>
          </p>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="text-center mt-6 text-xs text-[#475569]"
        >
          <Link
            to="/"
            data-testid="portal-back-home"
            className="inline-flex items-center gap-1 hover:text-[#0ABFBC] transition-colors"
          >
            ← Back to Home
          </Link>
        </motion.p>
      </div>
    </div>
  );
}
